"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@emotion/core");
const styles_scss_1 = __importDefault(require("./styles.scss"));
const Styles = {
    label: (props) => core_1.css `
      color: ${props.isOpen ? styles_scss_1.default.primary : styles_scss_1.default.darkGrey};
  `
};
exports.default = Styles;
